import AdminLayout from "../Layouts/AdminLayout";
import AdminDashboard from "../views/Admin/AdminDashboard";
import UserSearch from "../views/Admin/UserSearch";
import User from "../views/Admin/User";
import Vehicle from "../views/Admin/Vehicle";

const adminRoutes = [
    {
        path: '/admin',
        name: 'AdminDashboard',
        component: AdminDashboard,
        meta: {
            layout: AdminLayout,
            role: 'admin',
            title: 'Admin Layout'
        }
    },
    {
        path: '/admin/users/search',
        name: 'UserSearch',
        component: UserSearch,
        meta: {
            layout: AdminLayout,
            role: 'admin',
            title: 'User discovery starting point'
        }
    },
    {
        path: '/admin/users/:id',
        name: 'UserView',
        component: User,
        meta: {
            layout: AdminLayout,
            role: 'admin',
            title: 'Single user view'
        }
    },
    {
        path: '/admin/vehicles/:id',
        name: 'VehicleView',
        component: Vehicle,
        meta: {
            layout: AdminLayout,
            role: 'admin',
            title: 'Vehicle Trips and Tags'
        }
    },

];

export default adminRoutes;
